// Mock data for godquantum.tech landing page

export const mockData = {
  // Company Info
  company: {
    name: "Godquantum Systems",
    tagline: "Adding Qubits to Life",
    location: "Bengaluru, Karnataka, India",
    founder: "Arun Singh",
    mission: "Building the world's first commercially available Quantum Operating System"
  },

  // Navigation
  navigation: [
    { id: "vision", label: "Vision" },
    { id: "quantumos", label: "Quantum OS" },
    { id: "domains", label: "Applications" },
    { id: "partners", label: "Partners" },
    { id: "faq", label: "FAQ" }
  ],

  // Hero metrics
  metrics: [
    { value: "99.99%", label: "QoS target", description: "Quality of Service reliability" },
    { value: "<1ms", label: "Control latency", description: "Ultra-low latency quantum control" },
    { value: "NDA", label: "Design partner", description: "Exclusive partnership program" }
  ],

  // Vision pillars
  visionPillars: [
    {
      title: "Sovereign Compute",
      description: "Control planes and toolchains designed for national missions, defence‑grade hardening, and export‑ready commercial use.",
      icon: "shield"
    },
    {
      title: "Industry at Depth",
      description: "Material science, chemicals, drug discovery, energy, telecom, finance, automotive, semicon, aerospace, logistics.",
      icon: "layers"
    },
    {
      title: "Fault‑Tolerance First", 
      description: "Architected for error correction readiness, hybrid orchestration, and verifiable outcomes across qubits and classical fabric.",
      icon: "zap"
    }
  ],

  // Quantum OS Components
  quantumOSComponents: [
    {
      title: "Control Plane",
      description: "Deterministic timing, pulse‑level control, circuit schedulers, and routing across QPUs.",
      icon: "cpu"
    },
    {
      title: "Kernel & Drivers",
      description: "Abstractions for qubits, couplers, resonators; vendor‑agnostic HAL and FFI.",
      icon: "code"
    },
    {
      title: "Security",
      description: "Post‑quantum cryptography, HSM integration, and secure enclaves for workload isolation.",
      icon: "lock"
    },
    {
      title: "Networking",
      description: "Quantum repeaters, entanglement management, and classical back‑channels for orchestration.",
      icon: "network"
    },
    {
      title: "Observability",
      description: "Shot‑level telemetry, qubit health, error syndromes, and correlated traces to classical spans.",
      icon: "eye"
    },
    {
      title: "SDK & Tooling",
      description: "Compilers, optimizers (Grover, QAOA, VQE), and domain templates for rapid prototyping.",
      icon: "globe"
    }
  ],

  // Application domains - Enhanced with requested industries
  applicationDomains: [
    "AI/ML", "Robotics", "Urban Planning", "Mass Rapid Transit Transport", 
    "Agriculture & Crops Sciences", "Meteorological Forecasting", "Traffic Engineering Management",
    "Material Science", "Chemicals", "Drug Discovery", "Energy Utilities",
    "Telecom", "Finance (Risk/Portfolio)", "Industrial IoT", "Automotive",
    "Clean Tech", "Semiconductor", "Photonics", "Aerospace", "Defence",
    "Space Tech", "Logistics", "Supply Chain", "Maritime/Naval", "Avionics",
    "Cyberwarfare Intelligence", "Bio‑Life Sciences"
  ],

  // Stealth narrative
  stealthNarrative: {
    title: "Stealth, by Design",
    description: "The entrepreneurship journey is often solitary. We build quietly—prioritizing security, credible science, and industrial outcomes. The public story remains minimal while we validate fault‑tolerant primitives, compile IP, and co‑design with early partners.",
    milestones: [
      "6–12 month stealth build with progressive disclosures",
      "Co‑development MoUs with research labs & strategic customers", 
      "Patentable claims across control, error management & scheduling",
      "India NQM alignment; export‑ready architecture"
    ],
    founderNote: "We seek mentors, partners, and believers. If you resonate with a sovereign Quantum OS—and a practical path to quantum advantage—let's build together.",
    founder: "Arun Singh, Founder & CTO"
  },

  // FAQ
  faq: [
    {
      question: "Are you a hardware or software company?",
      answer: "Both. We build software that controls and composes quantum hardware, and collaborate with device makers for reference stacks."
    },
    {
      question: "When can we access the Quantum OS?",
      answer: "We are granting pre‑GA access to select design partners in phases during stealth, followed by a broader preview."
    },
    {
      question: "Do you support post‑quantum security?",
      answer: "Yes. PQC is a first‑class concern: signatures, key exchange, and secure enclaves integrated across control and data planes."
    },
    {
      question: "Can we collaborate under India NQM?",
      answer: "Yes. We welcome academia/government programs aligned with national missions and export‑compliant collaboration models."
    },
    {
      question: "What makes your approach different?",
      answer: "We focus on fault‑tolerance first, vendor‑agnostic QPU abstraction, and deterministic control over hybrid compute workloads."
    },
    {
      question: "How do you ensure quantum advantage?",
      answer: "Through verifiable execution paths, error correction readiness, and optimization for hard problems in specific verticals."
    }
  ],

  // Contact information
  contact: {
    general: {
      email: "contact@godquantum.tech",
      location: "Bengaluru, Karnataka, India"
    },
    investors: {
      description: "Request deck & data room (NDA)",
      action: "Join Waitlist"
    },
    careers: {
      description: "Deep‑tech builders: control, compilers, firmware, cryo, RF, error‑correction, distributed systems.",
      action: "Express Interest"
    }
  },

  // Partner logos (placeholder)
  partners: Array(12).fill().map((_, i) => ({
    id: i + 1,
    name: `Partner ${i + 1}`,
    logo: "LOGO", // Placeholder
    nda: true
  })),

  // External links
  externalLinks: {
    googleForm: "https://forms.gle/oLirQqXxYpqUh6Fp6", // Design partner waitlist form
    airtableForm: "https://airtable.com/your-form-url" // Alternative: Airtable form
  }
};

export default mockData;